import {createReducer} from "redux-act";
import * as actions from "modules/actions";
import {ILeague} from "modules/types";

export interface IJoinLeaguesReducer {
	leagues: ILeague[];
	fetched: boolean;
	next: boolean;
	filters: {
		q?: string;
		event_id?: number;
	};
}

const initialState: IJoinLeaguesReducer = {
	leagues: [],
	fetched: false,
	next: false,
	filters: {},
};

export interface IPostFetchLeaguesForJoin {
	q?: string;
	event_id?: number;
	offset?: number;
	limit?: number;
}

export const join_leagues = createReducer({}, initialState)
	.on(actions.fetchLeaguesForJoinSuccess, (state, payload) => ({
		...state,
		leagues: payload.leagues,
		next: payload.next,
		fetched: true,
	}))
	.on(actions.fetchLeaguesForJoinFailed, () => initialState);
